import { UNIVERSAL_SEARCH_API_HOST } from '../../config/index';

export const getUniversalSearchUrl = () => {
  return `${UNIVERSAL_SEARCH_API_HOST}/api/v1/autosuggest`;
};
